module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-3600.f9197f92.svg";